module.exports = __webpack_public_path__ + "img/joao_dias.5b003959.jpg";